<div class="row g-3">
	<div class="col-6 col-md-3">
		<h6 class="text-muted small mb-1">Demandeur</h6>
		<app-profile-avatar [image]="demandeur?.avatar?.url" [nom]="demandeur?.nom"></app-profile-avatar>
	</div>
	<div class="col-6 col-md-3">
		<h6 class="text-muted small mb-1">Superviseur</h6>
		<app-profile-avatar [image]="superviseur?.avatar?.url" [nom]="superviseur?.nom"></app-profile-avatar>
	</div>

	<div class="col-6 col-md-2">
		<h6 class="text-muted small mb-1">Date de la demande</h6>
		<div>{{ dateDemande }}</div>
	</div>
	<div class="col-6 col-md-2">
		<h6 class="text-muted small mb-1">Prix total</h6>
		<div>MAD {{ prixTotal | truncateDecimal }}</div>
	</div>
	@if (isDisabledpriorite) {
		<div class="col-6 col-md-2">
			<h6 class="text-muted small mb-1">Priorité</h6>
			<div class="d-flex align-items-center">
				<div class="flex-shrink-0 me-2">
					<app-priority [priorite]="priorite"></app-priority>
				</div>
				<div class="flex-grow-1">{{ priorite }}</div>
			</div>
		</div>
	}
</div>
